import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { media } from '../../interfaces/interfaces';
import { createDisplayLink } from '../../services/helper';
import { VYSTEMBLUE } from '../../static/constants';

interface PublicMediaComponentProps {
  media: media;
  showTitles?: boolean;
  textColor?: string;
  backgroundColor?: string;
}
const PublicMediaComponent = ({ media, showTitles, textColor, backgroundColor = VYSTEMBLUE }: PublicMediaComponentProps) => {
  const isVideo =
    (media.type === 'vystemvideo' || media.type === 'meetingRecording' || media.type === 'streamRecording') &&
    !!media?.playback_ids &&
    media?.playback_ids?.length > 0;

  function getBackgroundImageURL() {
    if (!media) return;

    return media.type === 'preuploadpresentation' && media.thumbnail
      ? createDisplayLink(media.thumbnail)
      : media.type === 'image'
      ? media.thumbnail
        ? createDisplayLink(media.thumbnail)
        : createDisplayLink(media.file)
      : media.type === 'pdf' && media.thumbnail
      ? createDisplayLink(media.thumbnail)
      : isVideo
      ? `https://image.mux.com/${media.playback_ids![0]?.id}/animated.gif?width=418&height=236&fit_mode=pad&time=45`
      : '';
  }

  function getThumbnail() {
    if (media.thumbnail) return `https://static.vystem.io/${media.thumbnail}`;
    return `https://image.mux.com/${media.playback_ids![0]?.id}/thumbnail.png?width=418&height=242&fit_mode=pad`;
  }

  return (
    <>
      <div
        className="box w-[335px] relative cursor-pointer h-0 pt-[56.25%] bg-cover bg-no-repeat bg-center rounded-md z-10"
        style={{ backgroundColor: backgroundColor, backgroundImage: `url(${getBackgroundImageURL()})` }}>
        {isVideo && (
          <div
            className="absolute top-0 left-0 z-20 w-full h-full transition-opacity bg-center bg-no-repeat bg-cover rounded-md opacity-100 hover:opacity-0"
            style={{ backgroundImage: `url(${getThumbnail()})` }}></div>
        )}
        <div className="absolute top-0 left-0 w-full h-full p-4">
          {media.type === 'pdf' && !media.thumbnail && (
            <div className="absolute inset-0 flex items-center justify-center w-full h-full">
              <PictureAsPdfIcon />
            </div>
          )}
        </div>
      </div>
      {showTitles && (
        <div style={{ width: '335px', color: textColor ?? '#6B7280' }} className="flex flex-col items-start justify-end h-full break-all">
          <span className="text-xs font-light break-all line-clamp-2">
            {media.number && media.number} {media.author}
          </span>
          <h4 className="text-base break-all line-clamp-2">{media.name}</h4>
        </div>
      )}
    </>
  );
};

export default PublicMediaComponent;
